<template>
    <v-window v-model="TabsPrimaryValue" v-bind="$attrs" @change="TabsPrimaryValueChange">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </v-window>
</template>

<script>
export default {
    props: {
        value: { type: [Number, String] },
    },
    components: {},
    data() {
        return {};
    },
    computed: {
        TabsPrimaryValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit("change", newValue);
            },
        },
    },
    mounted() {},
    methods: {
        TabsPrimaryValueChange(newValue) {
            this.TabsPrimaryValue = newValue;
        },
    },
};
</script>

<style lang="scss" scoped></style>